export default __webpack_public_path__ + "static/media/delete.2870f5fc.png";